import { render } from "./EmployeeLeaveHistory.vue?vue&type=template&id=e2deede4&scoped=true"
import script from "./EmployeeLeaveHistory.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveHistory.vue?vue&type=script&lang=js"

import "./EmployeeLeaveHistory.vue?vue&type=style&index=0&id=e2deede4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2deede4"]])

export default __exports__